import { createFileRoute } from "@tanstack/react-router";

/** Ruta comercial legada. La adquisición de FM vive en structura.com.ar. */
export const Route = createFileRoute("/landing/$nicho")({
  component: LegacyLandingNicheRedirect,
});

function LegacyLandingNicheRedirect() {
  if (typeof window !== "undefined") {
    window.location.replace("https://structura.com.ar/");
  }
  return null;
}
